import { mangaCategories } from '@/mocks/manga';

interface GenreVisual {
  id: string;
  img: string;
  tag: string;
}

const genreVisuals: GenreVisual[] = [
  {
    id: 'rexue',
    img: 'https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20cover%20art%2C%20fierce%20young%20fighter%20surrounded%20by%20coral%20red%20fire%20energy%20and%20speed%20lines%2C%20dynamic%20action%20pose%2C%20bold%20ink%20outline%2C%20dramatic%20lighting%2C%20dark%20background%2C%20high%20detail%2C%20clean%20composition&width=600&height=400&seq=genre-rexue&orientation=landscape',
    tag: '热血燃向',
  },
  {
    id: 'xuanhuan',
    img: 'https://readdy.ai/api/search-image?query=epic%20manga%20comic%20cover%20art%2C%20xianxia%20cultivator%20in%20flowing%20robes%20floating%20above%20misty%20mountains%2C%20glowing%20golden%20energy%20and%20sword%20light%2C%20oriental%20ink%20style%2C%20dramatic%20clouds%2C%20high%20detail%2C%20ethereal%20lighting%2C%20clean%20composition&width=600&height=400&seq=genre-xuanhuan&orientation=landscape',
    tag: '仙侠玄幻',
  },
  {
    id: 'xanyi',
    img: 'https://readdy.ai/api/search-image?query=mystery%20manga%20comic%20cover%20art%2C%20detective%20silhouette%20under%20streetlight%20in%20night%20fog%2C%20moody%20amber%20and%20indigo%20tones%2C%20crimson%20clue%20strings%20in%20air%2C%20noir%20atmosphere%2C%20ink%20shading%2C%20high%20detail%2C%20clean%20composition&width=600&height=400&seq=genre-xanyi&orientation=landscape',
    tag: '烧脑悬疑',
  },
  {
    id: 'kehuan',
    img: 'https://readdy.ai/api/search-image?query=hard%20sci-fi%20manga%20comic%20cover%20art%2C%20astronaut%20and%20giant%20mecha%20on%20alien%20planet%20with%20two%20moons%2C%20orange%20and%20teal%20thruster%20glow%2C%20technological%20detail%2C%20dramatic%20scale%2C%20high%20detail%2C%20clean%20composition&width=600&height=400&seq=genre-kehuan&orientation=landscape',
    tag: '硬核科幻',
  },
  {
    id: 'lianai',
    img: 'https://readdy.ai/api/search-image?query=sweet%20romance%20manga%20comic%20cover%20art%2C%20couple%20under%20pink%20cherry%20blossoms%20with%20sparkles%20and%20petals%2C%20soft%20pastel%20pink%20and%20warm%20yellow%20lighting%2C%20gentle%20smiles%2C%20delicate%20linework%2C%20high%20detail%2C%20clean%20background&width=600&height=400&seq=genre-lianai&orientation=landscape',
    tag: '甜蜜恋爱',
  },
  {
    id: 'maoxian',
    img: 'https://readdy.ai/api/search-image?query=adventure%20manga%20comic%20cover%20art%2C%20young%20explorer%20with%20backpack%20standing%20at%20cliff%20overlooking%20vast%20fantasy%20land%2C%20emerald%20valley%20and%20golden%20sunlight%2C%20epic%20panorama%2C%20clean%20linework%2C%20high%20detail%2C%20inspiring%20atmosphere&width=600&height=400&seq=genre-maoxian&orientation=landscape',
    tag: '热血冒险',
  },
];

export default function GenresSection() {
  return (
    <section id="genres" className="bg-background-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
              <i className="ri-compass-3-fill text-primary-500" />
              题材分类
            </h2>
            <p className="mt-1 text-sm text-foreground-600">十多种题材任你挑选，总有一部对上胃口</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {genreVisuals.map((g) => {
            const cat = mangaCategories.find((c) => c.id === g.id);
            return (
              <a
                key={g.id}
                href="#updates"
                className="group relative h-44 overflow-hidden rounded-lg ring-1 ring-background-200/70"
              >
                <img
                  src={g.img}
                  alt={`${cat?.name ?? ''}题材漫画 - ${g.tag}`}
                  title={`${cat?.name ?? ''}漫画分类`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4">
                  <div>
                    <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                      <i className={`${cat?.icon ?? 'ri-book-line'} text-accent-400`} />
                      {cat?.name ?? '分类'}
                    </h3>
                    <p className="mt-0.5 text-xs text-foreground-400">{g.tag}</p>
                  </div>
                  <span className="rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-accent-400 backdrop-blur">
                    {cat?.count ?? 0} 部
                  </span>
                </div>
              </a>
            );
          })}

          <div className="flex h-44 flex-col items-center justify-center gap-2 rounded-lg bg-primary-500/10 ring-1 ring-primary-500/30 text-center p-4">
            <i className="ri-more-fill text-3xl text-primary-400" />
            <p className="text-sm font-medium text-foreground-800">还有 50+ 种细分题材</p>
            <p className="text-xs text-foreground-600">武侠、体育、历史、搞笑……尽情探索</p>
            <a
              href="#updates"
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-xs text-background-50 transition hover:bg-primary-600"
            >
              全部浏览
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}